import { useState } from "react";
import {
  CNP_LENGTH,
  useSubmitCnp,
} from "@/features/onboarding/hooks/useSubmitCnp";
import { BotMessage } from "../../components/BotMessage";
import { TurnMessages } from "../../components/TurnMessages";
import { ChatComposer } from "../../components/ChatComposer";
import { ChatTurnLayout } from "../../components/ChatTurnLayout";
import { useTurnMessages } from "../../hooks/useTurnMessages";
import { chatCopy } from "../../engine/copy";
import type { ChatTurnProps } from "../../types/chat";

// Saved as soon as it is sent; the BC consent, when the scenario needs it,
// is the next step.
export function CnpTurn({ isPromptTyped, onAnswered }: ChatTurnProps) {
  const { messages, addUser, addError } = useTurnMessages();
  const [cnp, setCnp] = useState("");
  const { submitCnp, isLoading, cnpInUseModal } = useSubmitCnp({
    acceptsBcConsent: false,
    onError: addError,
  });

  const handleSend = async () => {
    addUser(cnp);
    setCnp("");

    if (await submitCnp(cnp)) {
      onAnswered();
    }
  };

  return (
    <>
      <ChatTurnLayout
        messageCount={messages.length}
        thread={
          <>
            <BotMessage lines={chatCopy.cnp} isTyped={isPromptTyped} />
            <TurnMessages messages={messages} />
          </>
        }
        actions={
          <ChatComposer
            label="CNP"
            placeholder="Scrie CNP-ul tău"
            inputMode="numeric"
            autoComplete="off"
            enterKeyHint="send"
            maxLength={CNP_LENGTH}
            value={cnp}
            onChange={(value) => setCnp(value.replace(/\D/g, ""))}
            onSubmit={() => void handleSend()}
            isLoading={isLoading}
          />
        }
      />
      {cnpInUseModal}
    </>
  );
}
